import React, { useMemo, useRef } from 'react'
import { Checkbox, Spin } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import {
  setHotelsFilterName,
  setHotelsFilterQuarter,
  setHotelsFilterQuarterAll
} from 'src/core/store/ducks/hotels/actions'
import { Text } from 'src/components/atoms'

import { WrapInput } from './styles'

function HotelFormFilterContent(): JSX.Element {
  const {
    hotels: { searches, currentPeriodKey }
  } = useSelector((state: ApplicationState) => ({
    hotels: state.hotels
  }))

  const dispatch = useDispatch()

  function handleChange(e: CheckboxChangeEvent): void {
    const index = e.target.value
    dispatch(setHotelsFilterQuarter({ index }))
  }

  function handleChangeAll(e: CheckboxChangeEvent): void {
    const { checked } = e.target
    dispatch(setHotelsFilterQuarterAll({ checked }))
  }

  const isLoading = useMemo(
    () => Object.values(searches).some(({ loading }) => loading),
    [searches]
  )

  const CheckboxAll = useMemo(
    () => !isLoading && Object.values(searches).some(({ loading }) => loading),
    [isLoading, searches]
  )

  if (isLoading) {
    return <Spin />
  }

  return (
    <>
      <Text strong suffix=": " text="web.services.hotels.filters.quarter" />
      {searches[currentPeriodKey]?.selectionFilters?.quarter?.length > 5 && (
        <div>
          <Checkbox checked={CheckboxAll} onChange={handleChangeAll}>
            <Text text="web.services.hotels.filters.select-all" />
          </Checkbox>
        </div>
      )}
      {searches[currentPeriodKey]?.selectionFilters?.quarter?.map(
        ({ checked, title }, index) => (
          <div key={title}>
            <Checkbox checked={checked} onChange={handleChange} value={index}>
              {title || <Text text="web.services.hotels.filters.uninformed" />}
            </Checkbox>
          </div>
        )
      )}
    </>
  )
}

export default function HotelFormFilter(): JSX.Element {
  const dispatch = useDispatch()
  const refTimeout = useRef<NodeJS.Timeout>(null)

  function handleChangeFindHotelName(
    e: React.ChangeEvent<HTMLInputElement>
  ): void {
    const value = e.target.value?.toLocaleUpperCase() || ''
    clearTimeout(refTimeout.current)
    refTimeout.current = setTimeout(() => {
      dispatch(setHotelsFilterName({ value }))
    }, 700)
  }
  return (
    <>
      <Text strong suffix=": " text="web.services.hotels.filters.name.title" />
      <WrapInput
        onChange={handleChangeFindHotelName}
        placeholder="web.services.hotels.filters.name.placeholder"
        required={false}
        size="large"
      />
      <HotelFormFilterContent />
    </>
  )
}
